import React from "react";
import StatsCards from "../UI/StatsCards";
import { getFixedNumber } from "../helper/formatters";

function StatsSection({ userCardInfo, filter }) {
  const STATS_DATA = [
    {
      title: "Total users",
      content: `${userCardInfo.total_users} Users`,
      info: `+${userCardInfo.new_users_this_month} ${
        filter.filterType === "Daily" ? "today" : "this month"
      }`,
      icon: "5",
      color: "blue",
    },
    {
      title: "Total Sessions",
      content: `${userCardInfo.total_sessions} Sessions`,
      info: `Avg. ${userCardInfo.avg_sessions_per_user} sessions per user`,
      icon: "4",
      color: "green",
    },
    {
      title: "Active Subscriptions",
      content: `${userCardInfo.premium_users} Premium Users`,
      info: `${userCardInfo.persentage_premium}% of total users`,
      icon: "3",
      color: "orange",
    },
    {
      title: "OpenAI Cost",
      content: `$${getFixedNumber(userCardInfo?.cost_data?.total_openai_cost)}`,
      info: `Across ${userCardInfo.total_sessions} sessions`,
      icon: "2",
      color: "blue",
    },
    {
      title: "Elevenlab Cost",
      content: `$${getFixedNumber(userCardInfo?.cost_data?.total_elevenlabs_cost)}`,
      info: `Across ${userCardInfo.total_sessions} sessions`,
      icon: "1",
      color: "dark",
    },
    {
      title: "AWS Transcribe Cost",
      content: `$${getFixedNumber(userCardInfo?.cost_data?.total_aws_transcribe_cost)}`,
      info: `Across ${userCardInfo.total_sessions} sessions`,
      icon: "2",
      color: "blue",
    },
  ];
  return (
    <>
      <StatsCards data={STATS_DATA.slice(0, 3)} />
      <StatsCards data={STATS_DATA.slice(3, STATS_DATA.length)} />
    </>
  );
}

export default StatsSection;
